
import CallRemove from "../../../assets/filled/CallRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CallRemoveIcon({ className, dataTestid = "CallRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CallRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
